import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import VCalendar from 'v-calendar'
import 'v-calendar/style.css'
import './assets/style.css'

const app = createApp(App)
app.use(router)
app.use(VCalendar, {
  componentPrefix: 'V' // Use <VDatePicker> instead of <DatePicker>
})
app.mount('#app')
